export enum ExecutionStatus{
    NoAction = 0,
    Success = 1,
    Error = 2,
    InValidRequest = 3,
    ExtraInfo = 4,
    ActionRequired = 5,
    CloseForm = 6,
    ReloadForm = 7
}
